import React from "react";
import { Helmet } from "react-helmet-async";

// meta.canonical (optional): an absolute https://tripsi.pl/... URL. Pages with query-string
// variants that don't represent genuinely distinct content (search results filtered only by
// dates/sort/pagination, the same listing crawled under both tripsi.pl and www.tripsi.pl, etc.)
// should pass this so Google indexes one URL instead of flagging "Duplicate without user-selected
// canonical" for every parameter combination it happens to crawl - see tour-list-v1's own comment
// on what it passes and why.
export default function MetaComponent({ meta }) {
  return (
    <Helmet>
        <title>{meta?.title}</title>
        <meta name="description" content={meta?.description} />
        {meta?.canonical && <link rel="canonical" href={meta.canonical} />}
        <meta name="robots" content={meta?.robots || "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1"} />
        <meta property="og:locale" content="pl_PL" />
        <meta property="og:site_name" content="tripsi.pl" />
        <meta property="og:type" content={meta?.type || "website"} />
        <meta property="og:title" content={meta?.title} />
        <meta property="og:description" content={meta?.description} />
        {meta?.canonical && <meta property="og:url" content={meta.canonical} />}
        {meta?.image && <meta property="og:image" content={meta.image} />}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={meta?.title} />
        <meta name="twitter:description" content={meta?.description} />
        {meta?.image && <meta name="twitter:image" content={meta.image} />}
    </Helmet>
  );
}
